export const webshop = {
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'webshop',
      pt3: 'op maat gemaakt voor restaurants'
    },
    description: 'Maak het jezelf makkelijk met de Bistroo webshop. Onze klanten besparen tijd, werken efficiënter én zien hun inkomsten groeien.'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Verhoog je omzet, verlaag je kosten',
      text: 'Een goed geoptimaliseerde webshop kan zorgen voor meer bestellingen én hogere orderwaarden vergeleken met traditionele bestelmethoden. Bespaar tot 20% op operationele kosten en tijd, en verwerk moeiteloos meer bestellingen dan ooit tevoren.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_2: {
      title: 'Betaal pas als je de meerwaarde hebt geproefd',
      text: 'Van volledig gratis pakketten tot toegankelijke maandabonnementen, kies welk prijspakket bij jouw smaak past en ontdek zelf wat de producten van Bistroo voor je kunnen doen. Dankzij een gratis proefperiode probeer je het eenvoudig uit, zonder dat je meteen vastzit aan een contract.',
      cta: ''
    },
    paragraph_3: {
      title: 'Bestel via Google',
      text: 'Wij zetten je letterlijk op de kaart. We optimaliseren je webshop, voor Google Search en Google Maps. Wij volgen de innovaties op het gebied van online verkeer en zorgen dat jouw webshop altijd makkelijk te vinden blijft. Deze optie is inclusief in alle Bistroo-pakketten.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_4: {
      title: 'Pas aan naar jouw merk',
      text: 'Een compleet white-label pakket is beschikbaar, waarmee je de volledige klant ervaring in de stijl van jouw restaurant kunt vormgeven. Van de landingspagina tot het bestel- en bevestigingsproces. Alles in jouw unieke stijl.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Verwerk bestellingen moeiteloos.',
        text: 'Beheer elke bestelling tot in de puntjes, altijd en overal, vanaf elk apparaat. Print bonnen zoals jij het wilt, op elk type printer.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Upselling opties.',
        text: 'Stel uitgebreide up-sell opties in en verhoog de gemiddelde orderwaarde van je bestellingen.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Groei je omzet.',
        text: 'Tot wel 30% meer omzet met een geoptimaliseerde webshop.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Kortingen en loyaliteit.',
        text: 'Stel promoties, kortingen en loyaliteitsbeloningen in voor je terugkerende klanten.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Sinds we met Bistroo werken zien we onze to-go bestellingen oplopen gestegen, superfijn! Wanneer iets niet goed loopt, dan is Bistroo goed bereikbaar en lossen ze het direct op."',
    cta: 'Lees volledig verhaal',
    name: 'Marieke van Loon',
    job_title: 'Eigenaresse Xtra-social'
  }
}